"use client"

import { ChevronDown } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/src/components/ui/dropdown-menu"
import "./sort-dropdown.less"

export type SortValue = "composite" | "download" | "latest"

const SORT_OPTIONS: { value: SortValue; label: string }[] = [
  { value: "composite", label: "综合排序" },
  { value: "download", label: "最多下载" },
  { value: "latest", label: "最近更新" },
]

export function SortDropdown({
  value,
  onChange,
}: {
  value: SortValue
  onChange: (val: SortValue) => void
}) {
  const current = SORT_OPTIONS.find((o) => o.value === value)!
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="sort-dropdown__trigger">
          {current.label}
          <ChevronDown className="h-3 w-3 opacity-50" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="end"
        sideOffset={6}
        collisionPadding={16}
        className="liquid-glass-panel sort-dropdown__content"
      >
        {SORT_OPTIONS.map((opt) => (
          <DropdownMenuItem
            key={opt.value}
            onSelect={() => onChange(opt.value)}
            className={`sort-dropdown__item ${value === opt.value ? "sort-dropdown__item--active" : "sort-dropdown__item--inactive"
              }`}
          >
            {opt.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
